import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  private logoutTrigger$ = new Subject<void>();
  logout$ = this.logoutTrigger$.asObservable();

  triggerLogout() {
    this.logoutTrigger$.next();
  }
}